import styled from 'styled-components'

export const Container = styled.div`
  border-bottom: 1px solid #ededed;

  * {
    box-sizing: border-box;
  }

  .ReactCollapse--collapse {
    transition: height 300ms;
  }

  .collapse-content {
    width: 100%;
    text-align: left;
    padding: 0 20px;
    padding-bottom: 20px;
  }
`

export const CollapseTitle = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  padding: 20px 0;
  cursor: pointer;

  span {
    font-family: Ubuntu, sans-serif !important;
    font-weight: 300;
    text-rendering: optimizeLegibility;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    letter-spacing: 0.4px;
    font-size: 16px;
    line-height: 24px;
    color: ${({ isOpen }: { isOpen: boolean }) =>
      isOpen ? '#12a3bb' : '#646464'};
    font-weight: 700;
    text-transform: uppercase;
    font-smoothing: antialiased;
  }

  img {
    margin-right: 10px;
  }
`
